import React from 'react';

// Colores estables por nombre para que cada usuario sin foto se distinga a simple vista.
const PALETA = ['#2563eb', '#7c3aed', '#db2777', '#ea580c', '#0d9488', '#16a34a', '#ca8a04', '#475569'];

const iniciales = (nombre = '') => {
    const partes = nombre.trim().split(/\s+/).filter(Boolean);
    if (partes.length === 0) return '?';
    return (partes[0][0] + (partes.length > 1 ? partes[partes.length - 1][0] : '')).toUpperCase();
};

const colorPorNombre = (nombre = '') => {
    let hash = 0;
    for (let i = 0; i < nombre.length; i += 1) hash = (hash * 31 + nombre.charCodeAt(i)) >>> 0;
    return PALETA[hash % PALETA.length];
};

/** Avatar circular: foto si existe, si no iniciales sobre un color propio del usuario. */
const AvatarUsuario = ({ nombre, foto, size = 40, className = '', style = {} }) => {
    const base = {
        width: size,
        height: size,
        minWidth: size,
        borderRadius: '50%',
        overflow: 'hidden',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: '2px solid rgba(255,255,255,0.85)',
        boxShadow: '0 1px 4px rgba(0,0,0,0.18)',
        ...style,
    };
    if (foto) {
        return (
            <span className={className} style={base}>
                <img src={foto} alt={nombre || 'Usuario'} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            </span>
        );
    }
    return (
        <span
            className={className}
            style={{ ...base, background: colorPorNombre(nombre), color: '#fff', fontWeight: 700, fontSize: size * 0.4, letterSpacing: '0.5px' }}
            aria-label={nombre}
        >
            {iniciales(nombre)}
        </span>
    );
};

export default AvatarUsuario;
